<template>
    <Modal title="Regular Review" v-model="showModal" width="750">
      <div class="evaluate">
        <h3>Part one： Classroom status(minimum 2 stars, maximum 5 stars)  :</h3>
        <Form  ref="formData" 
           class="feedback form regluarForm" label-position="top" v-model="formData">
          <Row>
            <Col :span="20" >
              <Form-item label="Student's attention to the class：">
                <el-rate v-model="formData.rate1"  @change="handleChange"></el-rate>
              </Form-item>
            </Col>
          </Row>
          <Row>
            <Col :span="20" >
              <Form-item label="Class participation：">
                <el-rate v-model="formData.rate2" @change="handleChange"></el-rate>
              </Form-item>
            </Col>
          </Row>
          <Row>
            <Col :span="20" >
              <Form-item label="Classroom environment：">
                <el-rate v-model="formData.rate3"  @change="handleChange"></el-rate>
              </Form-item>
            </Col>
          </Row>
          <Row>
            <Col :span="20" >
              <Form-item label="Internet connection：">
                <el-rate v-model="formData.rate4"  @change="handleChange"></el-rate>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </div>
      <div class="evaluate">
          <h3>Part two: Class performance   :</h3>
          <el-alert
            :closable="false"
            title="I'm very happy to see you today. You have made wonderful progress participating the class activities and  I look forward to seeing you in the next class."
            type="info"
            description="There are some difficult parts in today's lesson, so please review and practice the following areas after class.">
          </el-alert>
          <p class="square">
            1.Pronunciation of the words: 
            <el-row>
              <div class="myList">
                <el-col :offset="1">
                  <li v-for="(item, index) in formData.word1" :key="index">
                    <input type="text" v-model="item.remark" class="msg">
                    <i class="el-icon-remove-outline" @click="deleteItem(formData.word1,index,3)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#FF463B;"></i>
                    <i class="el-icon-circle-plus-outline" @click="addItem(formData.word1)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#0ABB08;"></i>
                  </li>
              </el-col>
              </div>
            </el-row>
          </p>
          <p class="square">
            2.Usage of the words: 
            <el-row>
              <div class="myList">
                <el-col :offset="1">
                  <li v-for="(item, index) in formData.word2" :key="index">
                    <input type="text" v-model="item.remark" class="msg">
                    <i class="el-icon-remove-outline" @click="deleteItem(formData.word2,index,3)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#FF463B;"></i>
                    <i class="el-icon-circle-plus-outline" @click="addItem(formData.word2)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#0ABB08;"></i>
                  </li>
                </el-col>
              </div>
            </el-row>
          </p>
          <p class="square">
            3.Difficult sentences: 
            <el-row>
              <div class="myList">
                <el-col :offset="1">
                  <li v-for="(item, index) in formData.word3" :key="index">
                    <input type="text" v-model="item.remark" class="msg">
                    <i class="el-icon-remove-outline" @click="deleteItem(formData.word3,index,1)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#FF463B;"></i>
                    <i class="el-icon-circle-plus-outline" @click="addItem(formData.word3)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#0ABB08;"></i>
                  </li>
                </el-col>
              </div>
            </el-row>
          </p>
          <p class="square">
            4.Others(grammar, writing etc): 
            <el-row>
              <div class="myList">
                <el-col :offset="1">
                  <li v-for="(item, index) in formData.word4" :key="index">
                    <input type="text" v-model="item.remark" class="msg">
                    <i class="el-icon-remove-outline" @click="deleteItem(formData.word4,index,1)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#FF463B;"></i>
                    <i class="el-icon-circle-plus-outline" @click="addItem(formData.word4)" style="font-size:20px;margin-top:10px;cursor:pointer;color:#0ABB08;"></i>
                  </li>
                </el-col>
              </div>
            </el-row>
          </p>
      </div>
        <div class="evaluate">
          <h3>Other feedback（optional）:</h3>
          <h2 class="title">
            1. A message to the parent
          </h2>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter something..."
            v-model="formData.parent">
          </el-input>
          <h2 class="title">
            2. Homework
          </h2>
          <!-- <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter something..."
            v-model="StudentWriteReiviewFormData.remark">
          </el-input> -->
          <MultiUpload class="title" @on-file-change="changeFile" :num="1" :defaultFileList="formData.fileList"/>
          <h2 class="title">
            3.Student needs to adjust the material level
          </h2>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter something..."
            v-model="formData.levelMsg"
          ></el-input>
        </div>
      <div slot="footer">
        <Button type="text" size="large" @click="onClose">Cancel</Button>
        <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
      </div>
    </Modal>
</template>
<script>
    export default {
      name: 'StudentWriteReviewRegular',
      props: {
        formData: {
          type: Object,
          default: {
            return: {}
          }
        },
        value: {
          type: Boolean,
          default: {
            return: false
          }
        },
        openedId: {
          type: Number
        },
        reviewState: {
          type: Number
        },
        readonly: {
          type: Boolean,
          default: false
        },
      },
      data () {
        return {
          uid: '',
          openid: '',
          state: '',
          form: {
            rating: 4 
          },
          rateValue: 0,
          v1: 4,
          v2: 2,
          showModal: this.value,
          loading: false,
          lessonErrRule: {
            remark: [
              { type: 'string', required: true, message: ' ', trigger: 'blur' }
            ],
          }
        }
      },
      methods: {
        changeFile (fileList) {
          this.formData.fileList = fileList
        },
        deleteItem (element, index, limit) {
          if (element.length === 1) {
            this.$Message.warning(`can't not remove defalut input`)
            return 
          }
          if (element.length > limit) {
            element.splice(index, 1)
          } else {
            this.$Message.warning(`At least ${limit} words!`)
          }
        },
        addItem (element) {
          element.push({ remark: '' })
        },
        handleChange (value) {
          this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2
          this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2
          this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2
          this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2
        },
        starChange (v) {
          console.log(this.v2)  
          console.log(this.v2)
        },
        onClose () {
          this.$emit('on-close')
        },
        getWord (element) {
          let word = []
          element.forEach(v => {
            if (v.remark !== '') {
              word.push(v.remark)
            }
          })
          return word
        },
        hasNumWords (str, num) {
          const words = str.split(' ') // 将字符串按空格切割成单词数组
          return words.length >= num // 判断单词数量是否大于等于80
        },
        onload () {
          let self = this
          self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
            let {uid, regularComment} = res.data
            self.uid = uid
            if (regularComment) {
              let {part1, part2, part3} = JSON.parse(regularComment)
              let rateList = part1.split(',')
              let intList = rateList.map(v => parseInt(v, 10))
              if (rateList.length >= 4) {
                [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4] = intList
              }
              this.handleChange() // 判断一下 rate的值 
              this.formData.word1 = []
              part2[0].forEach(v => {
                this.formData.word1.push({remark: v})
              })
              this.formData.word2 = []
              part2[1].forEach(v => {
                this.formData.word2.push({remark: v})
              })
              this.formData.word3 = []
              part2[2].forEach(v => {
                this.formData.word3.push({remark: v})
              })
              this.formData.word4 = []
              part2[3].forEach(v => {
                this.formData.word4.push({remark: v})
              })
              this.formData.parent = part3[0]
              if (part3[1] !== '') {
                this.formData.fileList = [{url: part3[1]}]
              }else {
                this.formData.fileList = []
              }
              console.log('fileurl', this.formData.fileList)
              this.formData.levelMsg = part3[2]
            } else {
              [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4] = [2, 2, 2, 2]
              this.formData.word1 = [{remark: ''}, {remark: ''}, {remark: ''}]
              this.formData.word2 = [{remark: ''}, {remark: ''}, {remark: ''}]
              this.formData.word3 = [{remark: ''}]
              this.formData.word4 = [{remark: ''}]
              this.formData.fileList = []
              this.formData.levelMsg = ''
            } 
          })
        },
        onSubmit () {
          let self = this
          let word1 = this.getWord(this.formData.word1)
          if (word1.length < 3) {
            this.$Message.error('1.Pronunciation of the words: At least 3 words!')
            return 
          }
          let word2 = this.getWord(this.formData.word2)
          if (word2.length < 3) {
            this.$Message.error('2.Usage of the words: At least 3 words!')
            return 
          }
          let word3 = this.getWord(this.formData.word3)
          if (word3.length < 1) {
            this.$Message.error('3.Difficult sentences: At least 1  sentences!')
            return 
          }
          let word4 = this.getWord(this.formData.word4)
          let part1 = []
          part1.push(this.formData.rate1 + '')
          part1.push(this.formData.rate2 + '')
          part1.push(this.formData.rate3 + '')
          part1.push(this.formData.rate4 + '')
          let part2 = {
            0: word1,
            1: word2,
            2: word3,
            3: word4
          }
          let part3 = {
            0: this.formData.parent,
            1: this.formData.fileList.length > 0 ? this.formData.fileList[0].url : '',
            2: this.formData.levelMsg
          }
          let data = {
            part1: part1.join(','),
            part2: part2,
            part3: part3
          }
          let parmas = {}
          parmas.regularComment = JSON.stringify(data)
          parmas.lsnOpenId = self.openid
          parmas.reviewState = self.state
          parmas.uid = self.uid
          parmas.version = 1 
          this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
            self.$Message.success('success')
            self.showModal = false
          }).catch(function (e) {
            // this.loadingUpdate = false
          })
        },
      },
      watch: {
        reviewState (val) {
          this.state = val
        },
        openedId (val) {
          this.openid = val
        },
        myValue (val) { 
          console.log(this.v2)
          this.myValue = 2 
          this.v1 = 3
          this.$nextTick()
        },
        value (val) {
          this.showModal = val
          if (val === true) {
            console.log(1231321)
              // this.scoreCompute()
            this.onload()
          } else {
            // this.feedback = {}
            // this.visible = val
          }
        },
        showModal (val) {
          if (val === false) {
            this.$emit('on-close')
          }
        },
        formData (val) {
          if (val) {
            this.lessonErrFormData = val
          }
        }
      }
    }
</script>
<style>
.title {
  padding: 10px 0px 10px 0px ;
  font-size: 16px;
}
.msg::after {
  content: 'bug';
}
.square {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// StudentWriteReviewRegularModal.vue?2daf45d6